import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

// Servicios (Asegúrate de que las rutas sean correctas)
import { getHistorialCompras, getDetalleCompra } from '../../../services/HistorialComprasService';
import { anularCompras } from '../../../services/ComprasService';

// Estilos
import '../../static/Global.css';
import '../../static/Home.css';
import '../../static/Aside.css';
import '../../static/Flotante.css';
import '../../static/Movimiento.css';

function DashboardCompras() {
    // 1. Definición de Estados corregidos para Compras
    const [compras, setCompras] = useState([]);
    const [detalles, setDetalles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [compraSeleccionada, setCompraSeleccionada] = useState(null);
    
    const location = useLocation();

    // 2. Cargar cabeceras al montar el componente
    useEffect(() => {
        cargarCompras();
    }, []);

    const cargarCompras = async () => {
        setLoading(true);
        const data = await getHistorialCompras(); 
        setCompras(data);
        setLoading(false);
    };

    const verDetalle = async (compra) => {
        setCompraSeleccionada(compra);
        const data = await getDetalleCompra(compra.compra_id);
        setDetalles(data);
    };

    const handleAnular = async (e, id) => {
        e.stopPropagation(); 
        const confirmar = window.confirm(`¿Estás seguro de que deseas ANULAR la compra #${id}? El stock se reducirá automáticamente.`);
        
        if (confirmar) {
            try {
                // Llamamos al service de compras que creamos anteriormente
                const result = await anularCompras(id); 
                if (result.error) throw new Error(result.error);

                alert("Compra anulada con éxito.");
                cargarCompras(); // Refresca la tabla
            } catch (error) {
                alert("Error al anular: " + error.message);
            }
        }
    };

    // Función para estilo dinámico del estado
    const getEstadoStyle = (estado) => {
        if (estado === 'COMPRA ANULADA') return { color: '#dc3545', fontWeight: 'bold' };
        return { color: '#28a745', fontWeight: 'bold' };
    };

    return (
        <section className="main__content">
            <div className="table-container">
                <div className="table-header" style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2>GESTIÓN DE COMPRAS</h2>
                    <Link to="/DashboardRegistrarCompras" className="btn-vender-sidebar" style={{ backgroundColor: '#28a745' }}>
                        <i className="fa-solid fa-box-open"></i> Nueva Compra
                    </Link>
                </div>

                <div className="table-responsive">
                    <table className="novatech-table">
                        <thead>
                            <tr>
                                <th>ID Compra</th>
                                <th>Proveedor</th>
                                <th>Usuario</th>
                                <th>Fecha</th>
                                <th>Estado</th>
                                <th>Total</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="7">Cargando historial de compras...</td></tr>
                            ) : (
                                compras.map((c) => (
                                    <tr key={c.compra_id} onClick={() => verDetalle(c)} style={{ cursor: 'pointer' }}>
                                        <td>#{c.compra_id}</td>
                                        <td><strong>{c.proveedor}</strong></td>
                                        <td>{c.usuario}</td>
                                        <td>{c.fecha}</td>
                                        <td style={getEstadoStyle(c.estado)}>{c.estado}</td>
                                        <td>S/ {Number(c.total).toFixed(2)}</td>
                                        <td style={{ display: 'flex', gap: '10px' }}>
                                            <button className="btn-edit" title="Ver Detalle">
                                                <i className="fa fa-eye"></i>
                                            </button>
                                            
                                            {/* Solo mostramos el botón de anular si NO está anulada */}
                                            {c.estado !== 'COMPRA ANULADA' && (
                                                <button 
                                                    className="btn-delete" 
                                                    onClick={(e) => handleAnular(e, c.compra_id)}
                                                    title="Anular Compra"
                                                    style={{ backgroundColor: '#dc3545', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px' }}
                                                >
                                                    <i className="fa-solid fa-ban"></i>
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* ====== MODAL DE DETALLE ====== */}
            {compraSeleccionada && (
                <div className="modal-overlay" onClick={() => setCompraSeleccionada(null)}>
                    <div className="modal-content-custom animate__animated animate__fadeInDown" onClick={(e) => e.stopPropagation()}>
                        <button className="btn-close-modal" onClick={() => setCompraSeleccionada(null)}>X</button>
                        
                        <h3>DETALLE DE COMPRA: #{compraSeleccionada.compra_id}</h3>
                        <hr />
                        <div style={{ marginBottom: '15px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                            <p><strong>Proveedor:</strong> {compraSeleccionada.proveedor}</p>
                            <p><strong>Comprador:</strong> {compraSeleccionada.usuario}</p>
                            <p><strong>Fecha:</strong> {compraSeleccionada.fecha}</p>
                            <p><strong>Estado:</strong> <span style={getEstadoStyle(compraSeleccionada.estado)}>{compraSeleccionada.estado}</span></p>
                        </div>

                        <div className="table-responsive">
                            <table className="novatech-table">
                                <thead>
                                    <tr>
                                        <th>Producto</th>
                                        <th>Cant.</th>
                                        <th>Precio Compra</th>
                                        <th>Subtotal</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {detalles.map((d, index) => (
                                        <tr key={index}>
                                            <td>{d.nombre}</td>
                                            <td>{d.cantidad}</td>
                                            <td>S/ {Number(d.precio_compra).toFixed(2)}</td>
                                            <td>S/ {Number(d.subtotal).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div style={{ textAlign: 'right', marginTop: '20px' }}>
                            <h3 style={{ color: '#28a745' }}>Total: S/ {Number(compraSeleccionada.total).toFixed(2)}</h3>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}

export default DashboardCompras;